import MapLink from './Maplink';

export default MapLink;
